import ToolStylus from './ToolStylus';
import Shortcut from '../utils/Shortcut';
import { type IToolActionInput } from './Tool';

class ToolDuplicate extends ToolStylus {
  static toolName = 'Duplicate objects';
  static shortcut = new Shortcut('Cmd+D');

  static action({ controller, selection }: IToolActionInput) {
    if (!selection) return;

    controller.canvas.duplicateActiveSelection(duplicatedObjects => {
      const position = selection.absolutePosition();
      // Position the new objects 10% below and to the right of the original
      duplicatedObjects.forEach(duplicatedObject => {
        duplicatedObject.moveToCoords({
          left: duplicatedObject.left + position.width * 0.1,
          top: duplicatedObject.top + position.height * 0.1,
        });
      });
    });

    this.toolActionComplete({ controller });
  }
}

export default ToolDuplicate;
